import React, { useState, useEffect, useRef } from "react"
import { Link } from "gatsby"
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock"

export default function CookieConsent() {
  const [visible, setVisible] = useState(false)
  const modalRef = useRef(null)

  useEffect(() => {
    if (!localStorage.getItem("cookieConsent")) {
      setVisible(true)
    }
  }, [])

  useEffect(() => {
    const handler = () => setVisible(true)
    window.addEventListener("openCookieSettings", handler)
    return () => window.removeEventListener("openCookieSettings", handler)
  }, [])

  useEffect(() => {
    const el = modalRef.current
    if (visible && el) {
      disableBodyScroll(el)
    }
    return () => {
      if (el) enableBodyScroll(el)
    }
  }, [visible])

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted")
    window.location.reload()
  }

  // Withdrawing consent must actually stop/undo the processing (GDPR art. 7(3)):
  // expire any cookies previously set on this domain (e.g. leftover "_ga" from
  // older deploys) and unmount any YouTube iframes already on the page.
  // Cookies like "_ga" are set on a parent domain (".cibb.uc.pt"), so each name
  // is expired against every ancestor domain, not just the exact host.
  const clearFirstPartyCookies = () => {
    const hostParts = window.location.hostname.split(".")
    const domains = hostParts.map((_, i) => hostParts.slice(i).join("."))

    document.cookie.split(";").forEach(cookie => {
      const name = cookie.split("=")[0].trim()
      if (!name) return
      document.cookie = `${name}=; Max-Age=0; path=/`
      domains.forEach(domain => {
        document.cookie = `${name}=; Max-Age=0; path=/; domain=${domain}`
        document.cookie = `${name}=; Max-Age=0; path=/; domain=.${domain}`
      })
    })
  }

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined")
    clearFirstPartyCookies()
    window.location.reload()
  }

  if (!visible) return null

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-modal" ref={modalRef}>
        <span className="cookie-consent-modal__title">
          Do you authorise the use of cookies?
        </span>

        <div className="cookie-consent-modal__body">
          <p>
            This website does not set analytical or marketing cookies. The
            only cookies used are:
          </p>
          <br />
          <p>
            <strong>Multimedia</strong> — Embedded videos on our site are
            hosted on YouTube and may set cookies to enable playback and
            remember preferences. These are only loaded if you accept; if you
            decline, videos are not embedded.
          </p>
          <br />
          <p>
            Your choice is stored locally in your browser and no information
            is sent to us or to third parties.
          </p>
          <br />
          <p>
            Read our <Link to="/cookie-policy">Cookie Policy</Link> for full
            details.
          </p>
        </div>

        <p className="cookie-consent-modal__note">
          &#9432; You can change your preferences at any time via the "Cookie
          Preferences" link in the website footer.
        </p>

        <div className="cookie-consent-modal__actions">
          <button
            className="cookie-consent-modal__actions__btn"
            onClick={handleAccept}
          >
            Accept
          </button>
          <button
            className="cookie-consent-modal__actions__btn"
            onClick={handleDecline}
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  )
}
